module.exports = __webpack_public_path__ + "static/img/img_gyc_b.b630388b.png";